import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const VoiceVerificationPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [voiceVerificationConfig, setVoiceVerificationConfig] = useState<any>({
    isEnabled: true,
    verificationSystem: 'Manual',
    speechTexts: [],
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = async (event: any) => {
    let name = event.target.name
    let type = event.target.type
    let value = type === 'checkbox' ? event.target.checked : event.target.value

    setVoiceVerificationConfig({...voiceVerificationConfig, [name]: value})
    if (type === 'checkbox') {
      updateConfiguration({...voiceVerificationConfig, [name]: value})
    }
  }

  const handleSpeechTextChange = (index: number, value: string) => {
    const newSpeechTexts = [...voiceVerificationConfig.speechTexts]
    newSpeechTexts[index] = value
    setVoiceVerificationConfig({...voiceVerificationConfig, speechTexts: newSpeechTexts})
  }

  const handleAddSpeechText = () => {
    const newSpeechTexts = [...voiceVerificationConfig.speechTexts, '']
    setVoiceVerificationConfig({...voiceVerificationConfig, speechTexts: newSpeechTexts})
  }

  const handleRemoveSpeechText = (index: number) => {
    const newSpeechTexts = voiceVerificationConfig.speechTexts.filter((_: any, i: number) => i !== index)
    setVoiceVerificationConfig({...voiceVerificationConfig, speechTexts: newSpeechTexts})
    updateConfiguration({...voiceVerificationConfig, speechTexts: newSpeechTexts})
  }

  const onBlurUpdate = () => {
    updateConfiguration({...voiceVerificationConfig})
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('voice-verification')
    if (result.success && result.data) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      setVoiceVerificationConfig({
        isEnabled: parsedData.isEnabled ?? false,
        verificationSystem: parsedData.verificationSystem || 'Manual',
        speechTexts: Array.isArray(parsedData.speechTexts) ? parsedData.speechTexts : [],
      })
    }
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)

    if (result.success) {
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='card'>
      <div className='card-title p-8'>
        <h2>Voice Verification settings</h2>
      </div>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Voice verification</strong>
            </p>
            <p className='text-muted'>
              Enable or disable Voice Verification system
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isEnabled'
                checked={voiceVerificationConfig.isEnabled}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light mt-0 border-top'>
            <p>
              <strong className='headings-color'>Verification System</strong>
            </p>
            <p className='text-muted'>
              Choose whether verification is Manual (admin approves) or Auto (Gemini AI).
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body bg-white mt-0 border-top'>
            <select
              className='form-select form-select-solid w-200px'
              name='verificationSystem'
              value={voiceVerificationConfig.verificationSystem}
              onChange={handleChange}
              onBlur={onBlurUpdate}
            >
              <option value='Manual'>Manual</option>
              <option value='Auto'>Auto</option>
            </select>
          </div>

          <div className='col-lg-4 card-body bg-light mt-0 border-top'>
            <p>
              <strong className='headings-color'>Speech Texts</strong>
            </p>
            <p className='text-muted'>
              The list of texts users might be asked to read for verification.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body bg-white mt-0 border-top'>
            {voiceVerificationConfig.speechTexts.map((text: string, index: number) => (
              <div className='d-flex align-items-center mb-4' key={index}>
                <input
                  type='text'
                  className='form-control form-control-solid me-3'
                  value={text}
                  onChange={(e) => handleSpeechTextChange(index, e.target.value)}
                  onBlur={onBlurUpdate}
                  placeholder='Enter verification text here...'
                />
                <button
                  type="button"
                  className="btn btn-icon btn-light-danger w-40px h-40px flex-shrink-0"
                  onClick={() => handleRemoveSpeechText(index)}
                  title='Remove text'
                >
                  <i className='fa-solid fa-trash fs-4'></i>
                </button>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-light-primary"
              onClick={handleAddSpeechText}
            >
              <i className='fa-solid fa-plus me-2'></i> Add New Text
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VoiceVerificationPlugin
